import { CampaignNotFound } from "@/components/campaign-not-found";
import { CampaignShell } from "@/components/campaigns/campaign-shell/campaign-shell";
import { buildCampaignView } from "@/campaigns";
import { useCurrentCampaign } from "@/hooks/use-current-campaign";
import { useTranslation } from "react-i18next";

export const CampaignIndexRouter = () => {
  const current = useCurrentCampaign();
  const { t } = useTranslation();

  if (!current) {
    return <CampaignNotFound />;
  }

  // Every campaign type and state (incl. finished) renders through the shared
  // shell; the registry supplies the type-specific sidebar + primary tab.
  const view = buildCampaignView(current, t);
  if (!view) {
    return <CampaignNotFound />;
  }

  return <CampaignShell view={view} />;
};
